import { useEffect, useRef, useState } from 'react';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import { workshopModuleTagGroupActions, workshopModuleTagGroupApi } from '../../../../../../entities/module/tag-group/workshop-module-tag-group';
import BlockHeader from '../../../../../../components/pages/features/moduleWindow/editModuleWindow/blockHeader/BlockHeader';
import { Slider } from '../../../../../../widgets/slider';
import {
	TagGroupCard,
} from '../../../../../../shared/ui/group-card/TagGroupCard';
import { EmptyList } from '../../../../../../components/ui/empty-list/empty-list';
import { WorkshopTagGroupEditingModal } from '../edit-group-modal/WorkshopTagGroupEditingModal';
import { BindWorkshopTagGroupModal } from '../bind-group-tag-modal/BindWorkshopTagGroupModal';
import { UnbindWorkshopTagGroupModal } from '../unbind-group-tag-modal/UnbindWorkshopTagGroupModal';
import css from './EditWorkshopTagGroups.module.scss';
import { classNames } from '../../../../../../shared/libs/classNames';
import {
	IGetWorkshopTagGroupResponse,
} from '../../../../../../entities/module/tag-group/workshop-module-tag-group/model/types/types';

interface EditWorkshopTagGroupsProps {
	className?: string,
	isActive: boolean,
}

/**
 * Блок редактирования групп тегов модулей мастерской
 */
export const WorkshopModuleTagGroupsEditing = ({
	className,
	isActive,
}: EditWorkshopTagGroupsProps) => {
	const dispatch = useAppDispatch();
	const ref = useRef(null);
	const [tagGroups, setTagGroups] = useState<IGetWorkshopTagGroupResponse | undefined>();

	const { data: groups } = workshopModuleTagGroupApi.useGetWorkshopGroupsQuery({
		page: 1,
		limit: 127,
		search: '',
	});

	const openCreateModal = () => {
		dispatch(workshopModuleTagGroupActions.setIsCreateGroupModalActive(true));
	};

	const openDeleteGroupModal = (groupId: string) => {
		dispatch(workshopModuleTagGroupActions.setIsDeleteGroupModalActive(true));
		dispatch(workshopModuleTagGroupActions.setDeletingGroupId(groupId));
	};

	const openEditGroupModal = (groupId: string) => {
		dispatch(workshopModuleTagGroupActions.setIsEditingGroupModalActive(true));
		dispatch(workshopModuleTagGroupActions.setEditingGroupId(groupId));
	};

	const openBindModal = (groupId: string) => {
		dispatch(workshopModuleTagGroupActions.setIsBindingGroupModalActive(true));
		dispatch(workshopModuleTagGroupActions.setBindingGroupId(groupId));
	};

	const openUnbindModal = (groupId: string, tagId: number) => {
		dispatch(workshopModuleTagGroupActions.setIsUnbindingGroupModalActive(true));
		dispatch(workshopModuleTagGroupActions.setUnbindingGroupId(groupId));
		dispatch(workshopModuleTagGroupActions.setUnbindingTags([tagId]));
	};

	useEffect(() => {
		setTagGroups(groups);
	}, [groups, isActive]);

	return (
		<div className={classNames(css.wrapper, {}, [className])} ref={ref}>
			<BlockHeader
				title="Группа тегов"
				onBtnClick={openCreateModal}
				btnText="Добавить группу тегов"
			>
				{
					tagGroups?.tagGroups
						? (
							<div className={css.slider}>
								<Slider
									buttonScrollDistance={600}
									height={308}
									controlSize="big"
									parentRef={ref}
								>
									{
										tagGroups.tagGroups.map(group => (
											<TagGroupCard
												key={group.id}
												data={group}
												onDeleteTagGroup={openDeleteGroupModal}
												onEditTagGroup={openEditGroupModal}
												onBindTag={openBindModal}
												onUnbindTag={openUnbindModal}
											/>
										))
									}
								</Slider>
							</div>
						)
						: (
							<EmptyList
								title="Создайте первую группу тегов"
								needBtn={false}
							/>
						)
				}
			</BlockHeader>
			{/* <CreateWorkshopTagGroupModal /> */}
			{/* <CreateWorkshopModuleTagGroupModal /> */}

			<WorkshopTagGroupEditingModal />
			<BindWorkshopTagGroupModal />
			<UnbindWorkshopTagGroupModal />
		</div>
	);
};
